import React from 'react';
import s from './DateTimePicker.module.scss';
import DateTime from 'react-datetime';

const DateTimePicker = ({
  placeHolderText,
  disabled = false,
  className = '',
  onChange,
  onBlur,
  timeFormat,
  dateFormat,
  value = null,
  defaultValue,
  closeOnSelect,
  showClear = false,
  isValidDate,
  timeConstraints,
  onClear
}) => {
  const inputProps = { placeholder: placeHolderText, disabled };
  
  return (
    <div className={s.dateWrapper}>
      <DateTime
        className={`${s.wsaInput} ${className}`}
        onChange={onChange}
        onBlur={onBlur}
        timeFormat={timeFormat}
        dateFormat={dateFormat}
        value={value}
        defaultValue={defaultValue}
        closeOnSelect={closeOnSelect}
        showClear={showClear}
        inputProps={inputProps}
        isValidDate={isValidDate}
        timeConstraints={timeConstraints}
      />
      {showClear && (
        <span className={s.clearText} onClick={onClear}>
          {' '}
          x{' '}
        </span>
      )}
    </div>
  );
};

export default DateTimePicker;